<template>
    <div class="s-image-selector">
        <slot name="trigger" :open-file-selector="openFileSelector">
            <button @click="openFileSelector" v-if="!image">Add Photo</button>
        </slot>
        <input class="s-file-input" type="file" name="image" accept="image/*" ref="input"
            @change="loadImage($event.target.files[0])" />
        <transition name="fade">
            <div class="s-popup" v-if="popupOpened">
                <div class="s-popup-inner">
                    <div class="mb-3">
                        <button class="btn btn-outline-danger btn-sm s-cancel-btn" type="button"
                            @click="closePopup">取消</button>
                        <button class="btn btn-success btn-sm" type="button" @click="submitImage">確定</button>
                    </div>
                    <div>
                        <img :id="randomId" class="s-image" :src="image" />
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
  
<script>
import { v4 as uuidv4 } from 'uuid'

export default {
    data: () => ({
        popupOpened: false,
        randomId: null,
        image: null,
    }),
    methods: {
        openFileSelector() {
            this.$refs.input.click()
        },
        async loadImage(file) {
            this.popupOpened = true
            this.randomId = `image-${uuidv4()}`

            await this.$nextTick()

            const reader = new FileReader()

            reader.onload = (event) => {
                this.image = event.target.result
                this.$refs.input.value = null
            }

            reader.readAsDataURL(file)
        },
        closePopup() {
            this.image = null
            this.popupOpened = false
        },
        submitImage() {
            this.$emit('input', this.image)
            this.closePopup()
        },
    },
}
</script>
  
<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity .15s ease-in-out;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.s-file-input {
    visibility: hidden;
    overflow: hidden;
    width: 0;
    height: 0;
}

.s-popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    background-color: rgb(33 33 33 / 33%);
}

.s-popup-inner {
    width: calc(100% - 2rem);
    max-width: 480px;
    height: 600px;
    padding: 1rem;
    text-align: center;
    box-shadow: 0 0 0 0 rgb(90 113 208 / 11%), 0 4px 16px 0 rgb(167 175 183 / 33%);
    border: solid 1px #dde4eb;
    background-color: white;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.s-image {
    width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.s-cancel-btn {
    margin-right: 1rem;
}
</style>
  